import { PapiereItem } from '@/types/service-response'

export class ProjectBookingPapieri {
  public constructor (
    readonly ID: number,
    readonly Aktion: string | null,
    readonly Code: string | null,
    readonly Bezeichnung: string | null,
    readonly Formular: string | null,
    readonly Druckpflicht: boolean,
    readonly Druckstatus: boolean,
    readonly DruckVisible: boolean

  ) {}

  static createFromResponse (responseData: PapiereItem[]): Array<ProjectBookingPapieri> {
    let result: Array<ProjectBookingPapieri> = []
    if (responseData) {
      result = responseData.map((item: PapiereItem) => {
        return new ProjectBookingPapieri(
          item.ID,
          item.Aktion,
          item.Code,
          item.Bezeichnung,
          item.Formular,
          item.Druckpflicht,
          item.Druckstatus,
          item.DruckVisible

        )
      })
    }
    return result
  }
}
